const CHECKOUT_SELECTOR = '#CartDrawer-Checkout';
const DATE_SELECTOR = '#neo-input-date';
const MESSAGE_SELECTOR = '#CartDrawer-DeliveryValidationMessage';
const SLOT_SELECTOR = '[data-cart-delivery-slot]';
const WIDGET_SELECTOR = 'pickeasy-app-widget';
const ZIP_SELECTOR = '#delivery-location-zip';

let updateQueued = false;

function getElements() {
  const drawer = document.querySelector('cart-drawer');
  const button = drawer?.querySelector(CHECKOUT_SELECTOR);
  const widget = drawer?.querySelector(WIDGET_SELECTOR);

  return {
    button,
    dateInput: widget?.querySelector(DATE_SELECTOR),
    drawer,
    message: drawer?.querySelector(MESSAGE_SELECTOR),
    widget,
    zipInput: widget?.querySelector(ZIP_SELECTOR),
  };
}

function updateInputPlaceholder(input, placeholder) {
  if (input && placeholder && input.placeholder !== placeholder) {
    input.placeholder = placeholder;
  }
}

function translateDeliveryWidget(widget, slot) {
  if (!widget || !slot) return;

  const translations = new Map([
    ['Choose your preferred delivery time', slot.dataset.deliveryHeading],
    ['Select date', slot.dataset.selectDate],
    ['Select time', slot.dataset.selectTime],
    ['Zip code', slot.dataset.zipCode],
  ]);
  const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
  let textNode = walker.nextNode();

  while (textNode) {
    const sourceText = textNode.nodeValue.trim();
    const translatedText = translations.get(sourceText);
    if (translatedText && translatedText !== sourceText) {
      textNode.nodeValue = textNode.nodeValue.replace(sourceText, translatedText);
    }
    textNode = walker.nextNode();
  }

  widget.querySelectorAll('input').forEach((input) => {
    const translatedPlaceholder = translations.get(input.placeholder.trim());
    updateInputPlaceholder(input, translatedPlaceholder);
  });
}

function positionDeliveryWidget({ drawer, widget }) {
  const slot = drawer?.querySelector(SLOT_SELECTOR);
  if (!widget || !slot) return;

  if (widget.parentElement !== slot) slot.append(widget);
  translateDeliveryWidget(widget, slot);
}

function deliveryIsComplete(elements = getElements()) {
  if (!elements.widget) return true;

  return Boolean(elements.dateInput?.value.trim());
}

function updateCheckoutState() {
  updateQueued = false;

  const elements = getElements();
  positionDeliveryWidget(elements);
  const slot = elements.drawer?.querySelector(SLOT_SELECTOR);
  updateInputPlaceholder(elements.zipInput, slot?.dataset.zipCode);
  if (!elements.button) return;

  const isComplete = deliveryIsComplete(elements);
  elements.button.classList.toggle('is-delivery-incomplete', !isComplete);
  elements.button.setAttribute('aria-disabled', String(!isComplete));

  if (isComplete && elements.message) {
    elements.message.hidden = true;
  }
}

function queueCheckoutStateUpdate() {
  if (updateQueued) return;

  updateQueued = true;
  requestAnimationFrame(updateCheckoutState);
}

function showValidationMessage() {
  const elements = getElements();
  if (!elements.message) return;

  elements.message.hidden = false;

  if (!elements.zipInput?.value.trim()) {
    elements.zipInput?.focus();
  } else {
    elements.dateInput?.focus();
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest(CHECKOUT_SELECTOR);
  if (!button || deliveryIsComplete()) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  showValidationMessage();
}, true);

document.addEventListener('submit', (event) => {
  if (event.target.id !== 'CartDrawer-Form' || deliveryIsComplete()) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  showValidationMessage();
}, true);

document.addEventListener('input', queueCheckoutStateUpdate, true);
document.addEventListener('change', queueCheckoutStateUpdate, true);

document.addEventListener('focusin', (event) => {
  if (!event.target.matches(DATE_SELECTOR)) return;

  const drawerBody = event.target.closest('cart-drawer')?.querySelector('.cart-drawer__body');
  if (!drawerBody) return;

  const scrollTop = drawerBody.scrollTop;
  requestAnimationFrame(() => {
    drawerBody.scrollTop = scrollTop;
    requestAnimationFrame(() => {
      drawerBody.scrollTop = scrollTop;
    });
  });
}, true);

const initialize = () => {
  const drawer = document.querySelector('cart-drawer');
  const observerTarget = drawer || document.body;
  if (!observerTarget) return;

  new MutationObserver(queueCheckoutStateUpdate).observe(observerTarget, {
    childList: true,
    subtree: true,
  });

  updateCheckoutState();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
  initialize();
}
